import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { ListGroup, ListGroupItem, Button, Collapse, Media, FormGroup, Form, Label } from 'reactstrap'

import { useEditorState, useEditorActions } from '../../editor-context'
import { truncate } from 'utils'
function removeTagFormat(text = '') {
    return String(text).replace(/\$|,/g, '');
}

export function TagList() {
    const { t } = useTranslation();
    const { document: doc, isContentLocked, isEditable } = useEditorState();
    const { control, reset, handleSubmit, watch } = useFormContext({
        defaultValues: {
            tags: doc.tags
        }
    });
    const { updateDocument } = useEditorActions();

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'tags',
    })

    useEffect(() => {
        reset({
            tags: doc.tags
        })
    }, [doc.tags])

    const handleAddTag = () => {
        const newTag = {
            name: t('editor.tags.new_name'), 
            value: '', 
            isOpen: true,
            auto: false, 
            type: 'text',
        }
        append(newTag)
    }
    const handleRemoveTag = (tagIndex) => {
        remove(tagIndex)
    }
    const handleSave = () => {
        handleSubmit(data => {
            console.log({data2: data})
            updateDocument(data)
        })()
    }
    
    return (
        <ListGroup>
            {
                fields?.map((tag, index) => (
                    <TagItem 
                        key={tag._id}
                        name={`tags[${index}]`}
                        tag={tag}
                        index={index}
                        isEditable={isEditable}
                        onSave={handleSave}
                        onRemove={handleRemoveTag}
                    />
                ))
            }
            <Button  className="text-center m-1" color="light" hidden={isContentLocked} onClick={handleAddTag}>
                <i className="fas fa-plus"></i> {t('editor.tags.add')}
            </Button>
        </ListGroup>
    )
}

function TagItem({ name, tag, index, isEditable, onSave, onRemove }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(tag.isOpen);
    const { register } = useFormContext();

    const toggle = () => setIsOpen(open => !open)

    const tagName = useMemo(() => { 
        if (!tag.auto) return tag.name;

        let name = t(`editor.tags.${tag.subtype}`);
        if (tag.subtype === 'participant') {
            name += ` - ${tag.name}`
        }
        return name;
    }, [tag])

    const handleRemove = () => {
        onRemove(index)
    }

    const handleSave = () => {
        onSave();
        setIsOpen(false);
    }
   

    return (
        <ListGroupItem className="m-0 p-0 bg-light text-dark">
            <Media className="text-dark d-flex align-items-center border-bottom p-2">
                <Media body className="px-2">
                    <Media >{truncate(tagName, 25)}</Media>
                    <Media>
                        {tag.value ? tag.value : <i>{t('editor.tags.not_defined')}</i>}
                    </Media>
                </Media>
                <Media className="px-2" hidden={tag.auto || !isEditable}>
                    <Button color="light" onClick={toggle} >
                        <i className="fas pointer fa-pen" />
                    </Button>
                    <Button color="light" onClick={handleRemove} >
                        <i className="fas fa-times text-danger" />
                    </Button>
                </Media>
            </Media>
            <Collapse isOpen={!tag.auto && isOpen}>
                <Media  body className="p-2">
                    <Form>
                        <FormGroup>
                            <Label>{t('editor.tags.type')}:</Label>
                            <select class="form-control input-sm" name={`${name}.type`}  ref={register()}>
                                <option value="text">{t('editor.tags.type_text')}</option>
                                <option value="date">{t('editor.tags.type_date')}</option>
                                <option value="number">{t('editor.tags.type_number')}</option>
                                <option value="currency">{t('editor.tags.type_currency')}</option>
                            </select>
                        </FormGroup>
                        <FormGroup>
                            <Label>{t('editor.tags.name')}:</Label>
                            <input 
                                type="text" 
                                class="form-control input-sm" 
                                placeholder={t('editor.tags.name_placeholder')}
                                name={`${name}.name`} 
                                ref={register()}
                                defaultValue={tag.name} 
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>{t('editor.tags.value')}:</Label>
                            <input 
                                type="text" 
                                class="form-control input-sm" 
                                placeholder={t('editor.tags.value_placeholder')}
                                name={`${name}.value`}
                                ref={register()}
                                defaultValue={removeTagFormat(tag.value)}
                            />
                        </FormGroup>
                    </Form>
                    <div className="d-flex justify-content-end">
                        <Button color="light" class="text-right" onClick={handleSave}>
                            <i class="fas fa-check"></i> {t('editor.tags.save')}
                        </Button>
                    </div>
                   
                </Media>
            </Collapse>
        </ListGroupItem>
    )
}
